module.exports = {
      id: "chat-usage",
      viewBox: "0 0 45 35",
      url: "img/" + "sprite.svg#chat-usage",
      toString: function () {
        return this.url;
      }
    }